import styled from "styled-components";
import { Button } from "@sonder/ui/source/styled/primitives/Button";
import { colors, typeface } from "@sonder/ui/source/styled/theme";

interface TabButtonProps {
  selected?: boolean;
}
export const TabButton = styled(Button)<TabButtonProps>`
  border-color: transparent;
  border-style: solid;
  border-width: 3px 0;
  box-sizing: border-box;
  color: ${colors.gray1};
  font-family: ${typeface.primary};
  font-size: 1rem;
  font-weight: ${props => props.selected && "bold"};
  height: 2.25rem;
  padding: 0 0.2rem;
  border-bottom-color: ${props => props.selected && colors.blue2};

  &:hover:not(:disabled) {
    border-bottom-color: ${props => !props.selected && colors.grayE};
  }
  &:active:not(:disabled) {
    border-bottom-color: ${props => !props.selected && colors.blue7};
  }
  &:disabled {
    color: ${colors.grayA};
  }
`;
